import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/2A9MgRJRwdWSqwzZoPmF2Y/Imagen_Landing_Bono_1.png',
  label: 'BONO 1',
  title: 'El Azúcar Infantil',
  description: 'Lo que nadie les explica a los padres sobre el azúcar, el cerebro y el cuerpo de tus hijos.',
  value: '$18'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/5Nt1FANrEq4Xh2q2Ge5wCn/Imagen_Landing_Bono_2.png',
  label: 'BONO 2',
  title: 'Regula el Cortisol',
  description: 'Cómo el cortisol, el estrés y el mal sueño elevan tu glucosa en silencio.',
  value: '$18'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/nF1FqE6NR1sFtuXbStM62V/Imagen_Landing_Bono_3.png',
  label: 'BONO 3',
  title: 'Guía del Hogar Sin Azúcar Oculta',
  description: 'Detecta, elimina y reemplaza el azúcar oculta en tu hogar en 14 días.',
  value: '$18'
}];
export function Bonuses() {
  return <section className="relative bg-cream py-[40px] md:py-[64px] px-6" data-id="element-27">
      <div className="max-w-[860px] mx-auto" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-8 text-center" data-id="element-29">
          <p className="font-mono text-[11px] tracking-[0.15em] text-cocoa uppercase mb-6" data-id="element-30">
            INCLUIDO HOY · SIN COSTO ADICIONAL
          </p>

          <h2 className="font-serif font-[900] text-[42px] md:text-[44px] leading-[1.15] text-text-primary mb-4 max-w-[620px] mx-auto" data-id="element-31">
            Tres bonos exclusivos cuando compras hoy.
          </h2>

          <p className="font-lora text-[18px] text-text-secondary max-w-[620px] mx-auto" data-id="element-32">
            $54 de valor adicional. Tuyos gratis.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-33">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="premium-card p-8" data-id="element-34">
              <img src={bonus.image} alt={bonus.title} className="w-full h-auto mb-6 rounded-lg" data-id="element-35" />
              <p className="font-mono text-[11px] text-cocoa uppercase mb-2" data-id="element-36">
                {bonus.label}
              </p>
              <h3 className="font-serif font-bold text-[20px] text-text-primary mb-3" data-id="element-37">
                {bonus.title}
              </h3>
              <p className="font-lora text-[15px] leading-[1.7] text-text-secondary mb-4" data-id="element-38">
                {bonus.description}
              </p>
              <div className="flex items-center gap-2" data-id="element-39">
                <span className="text-[14px] text-text-muted line-through" data-id="element-40">
                  {bonus.value} valor
                </span>
                <span className="text-[16px] font-bold text-cocoa" data-id="element-41">GRATIS</span>
              </div>
            </motion.div>)}
        </div>
      </div>

      {/* Section Separator */}
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-b from-transparent to-[#FAF7F0]" data-id="element-42"></div>
    </section>;
}